// removed by extract-text-webpack-plugin
module.exports = {"collapse-container":"collapse-container","title-collapse":"title-collapse","open":"open"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/collapse/style.scss
// module id = ./components/partials/collapse/style.scss
// module chunks = 0